import isEqual from 'lodash/isEqual';
import { memo, useCallback, useEffect, useState } from 'react';
import ReactSelect from 'react-select';

import { useGetCommonProps } from './common';
import type { MultiSelectProps, SelectOption, SelectOptionAction } from './lib';
import { getValue } from './lib';

export const MultiSelect: FC<MultiSelectProps> = memo((props) => {
    const { options = [], defaultValue, value, max } = props;
    const commonProps = useGetCommonProps(props);

    const findSelected = useCallback(
        (v): Array<SelectOption> => {
            return v?.reduce((acc, item) => {
                const findOption = options?.find((o) => o?.value === getValue(item));

                if (findOption) {
                    acc.push(findOption);
                }

                return acc;
            }, []);
        },
        [options],
    );

    const [defaultSelected] = useState<Array<SelectOption>>(findSelected(defaultValue));
    const [selected, setSelected] = useState<Array<SelectOption>>();

    useEffect(() => {
        if (!isEqual(selected, findSelected(value))) {
            setSelected(findSelected(value));
        }
    }, [value, findSelected]);

    return (
        <ReactSelect
            {...commonProps}
            defaultValue={defaultSelected}
            value={selected}
            onChange={(options: Array<SelectOption>, action: SelectOptionAction) => {
                if (options.length > max) {
                    return;
                }
                setSelected(props.unselected ? null : options);
                props.onChange?.(options, action);
            }}
            isMulti={true}
            closeMenuOnSelect={false}
            blurInputOnSelect={false}
        />
    );
});
MultiSelect.displayName = 'MultiSelect';
